import { useState, useEffect, useCallback } from 'react';

export const useWindowResize = (
  callback: (this: Window, ev: UIEvent) => void
) => {
  useEffect(() => {
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, [callback]);
};

// https://usehooks.com/useWindowSize/
export const useWindowSize = () => {
  const isServerSide = RUNTIME_ENV === 'server';

  const getSize = useCallback(() => {
    return {
      width: isServerSide ? undefined : window.innerWidth,
      height: isServerSide ? undefined : window.innerHeight,
    };
  }, [isServerSide]);

  const [windowSize, setWindowSize] = useState(getSize);

  const handleResize = useCallback(() => {
    setWindowSize(getSize());
  }, [setWindowSize, getSize]);

  useWindowResize(handleResize);

  return windowSize;
};
